"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDayNumberInMonthList = void 0;
const types_1 = require("../types");
const getDayNumberInMonthList = () => [
    types_1.DAY_NUMBER_IN_MONTH.first,
    types_1.DAY_NUMBER_IN_MONTH.second,
    types_1.DAY_NUMBER_IN_MONTH.third,
    types_1.DAY_NUMBER_IN_MONTH.fourth,
    types_1.DAY_NUMBER_IN_MONTH.last,
    types_1.DAY_NUMBER_IN_MONTH.onDay,
];
exports.getDayNumberInMonthList = getDayNumberInMonthList;
//# sourceMappingURL=getDayNumberInMonthList.js.map